import React, { FC, useState } from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Button, Menu, MenuItem, Typography } from '@material-ui/core';
import { useHistory } from 'react-router';
import { AppRoute } from 'enums/appRoute';

export const UserMenu: FC = () => {
 const [anchorEl, setAnchorEl] = useState(null);
 const history = useHistory();

 const openUserMenu = (event: any) => setAnchorEl(event.currentTarget);
 const handleClose = () => setAnchorEl(null);

 const logout = () => {
  handleClose();
  localStorage.clear();
  history.replace(AppRoute.LOGIN);
 };

 return (
  <>
   <Button onClick={openUserMenu}>
    John Doe <KeyboardArrowDownIcon />
   </Button>
   <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
    <MenuItem onClick={handleClose}>My account</MenuItem>
    <MenuItem onClick={logout}>
     <Typography color='error'>Logout</Typography>
    </MenuItem>
   </Menu>
  </>
 );
};
